import { createStore } from 'vuex'
import operate_inspection from './inspection'

const store = createStore({
  actions: {
    clearAllStores({ dispatch }) {
      dispatch('operate_inspection/clearAll', null, { root: true })
    },
    clearDataStores({ dispatch }) {
      dispatch('operate_inspection/clearAll', null, { root: true })
    },
  },
  modules: {
    operate_inspection,
  },
})

export default store
